import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AuthController::showLogin
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
export const showLogin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLogin.url(options),
    method: 'get',
})

showLogin.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::showLogin
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
showLogin.url = (options?: RouteQueryOptions) => {
    return showLogin.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::showLogin
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
showLogin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showLogin.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AuthController::showLogin
* @see app/Http/Controllers/AuthController.php:41
* @route '/login'
*/
showLogin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showLogin.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::login
* @see app/Http/Controllers/AuthController.php:63
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

login.definition = {
    methods: ["post"],
    url: '/login',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::login
* @see app/Http/Controllers/AuthController.php:63
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::login
* @see app/Http/Controllers/AuthController.php:63
* @route '/login'
*/
login.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: login.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AuthController::showRegister
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
export const showRegister = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegister.url(options),
    method: 'get',
})

showRegister.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::showRegister
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
showRegister.url = (options?: RouteQueryOptions) => {
    return showRegister.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::showRegister
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
showRegister.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegister.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AuthController::showRegister
* @see app/Http/Controllers/AuthController.php:102
* @route '/register'
*/
showRegister.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showRegister.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::googleRedirect
* @see app/Http/Controllers/AuthController.php:191
* @route '/login/google'
*/
export const googleRedirect = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: googleRedirect.url(options),
    method: 'get',
})

googleRedirect.definition = {
    methods: ["get","head"],
    url: '/login/google',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::googleRedirect
* @see app/Http/Controllers/AuthController.php:191
* @route '/login/google'
*/
googleRedirect.url = (options?: RouteQueryOptions) => {
    return googleRedirect.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::googleRedirect
* @see app/Http/Controllers/AuthController.php:191
* @route '/login/google'
*/
googleRedirect.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: googleRedirect.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AuthController::googleRedirect
* @see app/Http/Controllers/AuthController.php:191
* @route '/login/google'
*/
googleRedirect.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: googleRedirect.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::register
* @see app/Http/Controllers/AuthController.php:124
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

register.definition = {
    methods: ["post"],
    url: '/register',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::register
* @see app/Http/Controllers/AuthController.php:124
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::register
* @see app/Http/Controllers/AuthController.php:124
* @route '/register'
*/
register.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AuthController::googleCallback
* @see app/Http/Controllers/AuthController.php:215
* @route '/login/google/callback'
*/
export const googleCallback = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: googleCallback.url(options),
    method: 'get',
})

googleCallback.definition = {
    methods: ["get","head"],
    url: '/login/google/callback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::googleCallback
* @see app/Http/Controllers/AuthController.php:215
* @route '/login/google/callback'
*/
googleCallback.url = (options?: RouteQueryOptions) => {
    return googleCallback.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::googleCallback
* @see app/Http/Controllers/AuthController.php:215
* @route '/login/google/callback'
*/
googleCallback.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: googleCallback.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AuthController::googleCallback
* @see app/Http/Controllers/AuthController.php:215
* @route '/login/google/callback'
*/
googleCallback.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: googleCallback.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:168
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:168
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:168
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\AuthController::me
* @see app/Http/Controllers/AuthController.php:30
* @route '/me'
*/
export const me = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: me.url(options),
    method: 'get',
})

me.definition = {
    methods: ["get","head"],
    url: '/me',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AuthController::me
* @see app/Http/Controllers/AuthController.php:30
* @route '/me'
*/
me.url = (options?: RouteQueryOptions) => {
    return me.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::me
* @see app/Http/Controllers/AuthController.php:30
* @route '/me'
*/
me.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: me.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AuthController::me
* @see app/Http/Controllers/AuthController.php:30
* @route '/me'
*/
me.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: me.url(options),
    method: 'head',
})

const AuthController = { showLogin, login, showRegister, googleRedirect, register, googleCallback, logout, me }

export default AuthController